export class ProductActive {
	
	id: number;
	name: string;
	description: string;
	code: string;
}